import { gql } from '@ts-gql/tag'

export const GetCentresQuery = gql`
  query getCentres($country: String!) {
    cfCentreCollection(where: { country: $country, status_not: "Closed" }) {
      items {
        title
        state
        country
        slug
        suburb
        status
        longitude
        latitude
      }
    }
  }
` as import('../../../../__generated__/ts-gql/getCentres').type
